import { useQuery } from "@tanstack/react-query";
import {
  Activity,
  ActivityQuery,
  FindingsActivity,
  MetricsActivity,
  ProtectedActivity,
} from "@theprelude/sdk";
import { queries } from "../lib/query-factory";
import { useAuthConfig } from "../main";

export function useProtectedActivityQuery<T = ProtectedActivity[]>(
  query: ActivityQuery,
  select?: (data: ProtectedActivity[]) => T,
) {
  const authConfig = useAuthConfig();

  return useQuery({
    ...queries.detect.activity.protected(authConfig, query),
    select,
  });
}

export function useTodayProtectedQuery(query: ActivityQuery) {
  return useProtectedActivityQuery(query, (data) => {
    const activity = data.at(-1);
    return activity ? Math.floor(activity.protected) : 0;
  });
}

export function useFindingsQuery<T = FindingsActivity[]>(
  query: ActivityQuery,
  select?: (data: FindingsActivity[]) => T,
) {
  const authConfig = useAuthConfig();

  return useQuery({
    ...queries.detect.activity.findings(authConfig, query),
    select,
  });
}

export function useLogsQuery<T = Activity[]>(
  query: ActivityQuery,
  select?: (data: Activity[]) => T,
) {
  const authConfig = useAuthConfig();

  return useQuery({
    ...queries.detect.activity.logs(authConfig, query),
    select,
  });
}

export function useMetricsQuery<T = MetricsActivity[]>(
  query: ActivityQuery,
  select?: (data: MetricsActivity[]) => T,
) {
  const authConfig = useAuthConfig();

  return useQuery({
    ...queries.detect.activity.metrics(authConfig, query),
    select,
  });
}
